export const COMPANY_EMAIL = "admin@encycdata.com";
